import Conclusao from './conclusao';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const mapStateToProps = state => ({
  conclusao: state.conclusaoReducer
});
const mapDispatchToProps = dispatch =>
  bindActionCreators({
  }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Conclusao);
